import React, {Component} from 'react';
import PropTypes from 'prop-types';
import DealerColumn from './DealerColumn';
import MarketOrders from './MarketOrders';
import DealerControls from './DealerControls';
import * as firebase from 'firebase';
import userStore from '../../stores/UserStore';
import { SSL_OP_SSLEAY_080_CLIENT_DH_BUG } from 'constants';

/**
 * Receives sessionid and uid props from simulationContainer
 *
 * this component acts as the simulationContainer for all
 * components in the actual orderbook.
 */

var joinfleestyle = {
  textAlign: "center",
  paddingTop: "5%",
  color: "#333"
};

var fromPlayersToArrays = function(players){
  //consumes an object like: {0: playerJson, 1: otherJSON, etc}
  //produces array of bids in order, an array of asks in order
  let keys = Object.keys(players);
  let bids = [];
  keys.sort();
  let asks = [];
  let counter = 0;
  keys.map(key=>{
    let cssClass = `player${counter}`;
    counter += 1;
    let player = players[key];
    bids.push({name: player.displayName, price: player.bid.toFixed(2), id: key, position: player.position, cssClass})
    asks.push({name: player.displayName, price: player.ask.toFixed(2), id: key, position: player.position, cssClass})
  });
  asks.sort((x,y)=>{
    return x.price - y.price;
  });
  let bestAsk = asks[0].price;
  counter = 0;
  let prevObj = {}
  asks.map(obj=>{
    if(obj.price == bestAsk){
      obj.cssClass += ` bestAsk${counter}`;
      prevObj = obj;
    }
    else{
      bestAsk = obj.price;
      counter += 1;
      obj.cssClass += ` bestAsk${counter}`;
      prevObj.cssClass += ` lastBestAsk${counter - 1}`;
      prevObj = obj;
    }
  })
  prevObj.cssClass += ` lastBestAsk${counter - 1}`;
  bids.sort((x,y)=>{
    return y.price - x.price;
  });
  let bestBid = bids[0].price;
  prevObj = {};
  counter = 0;
  bids.map(obj=>{
    if(obj.price == bestBid){
      obj.cssClass += ` bestBid${counter}`;
      prevObj = obj;
    }
    else{
      bestBid = obj.price;
      counter += 1;
      obj.cssClass += ` bestBid${counter}`;
      prevObj.cssClass += ` lastBestBid${counter - 1}`;
      prevObj = obj;
    }
  })
  prevObj.cssClass += ` lastBestBid${counter - 1}`;
  return [bids, asks];
}


class DealerContainer extends Component {
    constructor(props) {
        //console.log("OrderbookContainer created");
        super(props);
        this.state = {
          bids: [],
          asks: [],
          bid: 19.50,
          ask: 20.50,
          dealerKeys: []
        }

        var that = this;
        let thedb = props.db;
        this.dealerRef = thedb.child("Sessions").child(props.sessionid).child("Dealers");
        this.dealerRef.on("value", (snapshot)=>{
          let data = snapshot.val();
          if (!!data){
            let arrayResults = fromPlayersToArrays(data);
            let bid = 0;
            let ask = 100;
            if (data.hasOwnProperty(userStore.uid)){
              bid = data[userStore.uid].bid;
              ask = data[userStore.uid].ask;
            }
            let dealerKeys = Object.keys(data);
            this.setState({bids: arrayResults[0], asks: arrayResults[1], bid, ask, dealerKeys});
          }
        });
        // this.isNonDealer = this.isNonDealer.bind(this);
    }

    updateBidAskDB(newbid, newask){
      console.log('UPDATING BIDASK IN FIREBASE');
      let ordersPendingRef = this.props.db.child("Sessions").child(this.props.sessionid).child("Users").child(userStore.uid).child("OrdersPending");
      console.log(ordersPendingRef);
      let tempRef = ordersPendingRef.push();
      tempRef.set({
        "Class":"BidAskChange", "UserId": userStore.uid, "Bid": (newbid*100).toFixed(0), "Ask": (newask*100).toFixed(0)
      }

      )
      // alert(`Set bid: ${newbid} ask: ${newask} in DB please`);
    }
    componentDidMount() {



    }

    componentWillUnmount() {
      this.dealerRef.off();
    }

    flee(){
      //newbid = worst bid - 1
      //newask = worst ask + 1
      let asks = this.state.asks;
      let worstask = asks[asks.length-1].price;
      let bids= this.state.bids;
      let worstbid = bids[bids.length-1].price;
      this.updateBidAskDB(parseFloat(worstbid), parseFloat(worstask));
      console.log('FLEE END')
    }
    join(){
      console.log('JOIN');
      let asks = this.state.asks;
      let bestask = asks[0].price;
      let bids= this.state.bids;
      let bestbid = bids[0].price;
      this.updateBidAskDB(parseFloat(bestbid), parseFloat(bestask));
      console.log('JOIN END');
    }

    /**
     * Disables button for users not in Dealer Array
     */
    isNonDealer(){
      let keys = this.state.dealerKeys;
      console.log(keys);
      return !keys.includes(userStore.uid);
  }

    clicker(action, type){
      let playerbid = this.state.bid;
      let playerask = this.state.ask;
      let newbid = playerbid;
      let newask = playerask;
      if (action == "+"){
        if (type == "bid"){
          newbid += .1;
        } else if (type=="ask"){
          newask += .1;
        } else if (type=="quote"){
          newbid += .1;
          newask += .1;
        }
      } else if (action == "-"){
        if (type == "bid"){
          newbid -= .1;
        } else if (type=="ask"){
          newask -= .1;
        } else if (type=="quote"){
          newbid -= .1;
          newask -= .1;
        }
      }
      this.updateBidAskDB(newbid, newask);
    }

    /**
     * Conditionally renders limit orders based on state.ready
     * @returns {*}
     */
    render() {
        //console.log("OrderbookContainer render");
        //console.log(this.state.userSums);
        return (

            <div className="dealerContainerStyle">
              <div className="dealerContainerHeader">
                <div className="dealerContainerHeaderQuote">
                  <div>Quote</div>
                  <div className="dealerQuoteControls">
                    <DealerControls contdisb={this.isNonDealer()} contclick={this.clicker.bind(this)} type={'quote'}/>
                  </div>

                </div>
                <div className="dealerContainerHeaderBid">
                  <div>Bid</div>
                  <div className="dealerQuoteControls">
                    <DealerControls contdisb={this.isNonDealer()} contclick={this.clicker.bind(this)} type={'bid'}/>
                  </div>
                </div>
                <div className="dealerContainerHeaderSpread">
                  <div>${this.state.bid.toFixed(2)}</div>
                  <div>${this.state.ask.toFixed(2)}</div>

                </div>
                <section style={joinfleestyle}>
                  <button className="button-default" disabled={this.isNonDealer()} onClick={this.flee.bind(this)}>Risk Off</button>
                </section>
                <section style={joinfleestyle}>
                <button className="button-default" disabled={this.isNonDealer()} onClick={this.join.bind(this)}>Risk On</button>
                  </section>
                <div className="dealerContainerHeaderAsk">
                  <div>Ask</div>
                  <div className="dealerQuoteControls">
                    <DealerControls contdisb={this.isNonDealer()} contclick={this.clicker.bind(this)} type={'ask'}/>
                  </div>
                </div>
              </div>
              <MarketOrders
                    institution={this.props.institution}
                    paused={false}
                    uid={this.props.uid}
                    db={this.props.db}
                    sessionid={this.props.sessionid}
                  />
              <div 
                className="dealerContainerBody" 
                style={{ display: "flex" }}
              >
                <DealerColumn 
                 institution={this.props.institution}
                 uid={this.props.uid}
                 db={this.props.db}
                 sessionid={this.props.sessionid}
                 columnType="bid" 
                 players={this.state.bids}
                 solo ={this.props.solo}
                 creator = {this.props.creator}
                />
                <DealerColumn 
                 institution={this.props.institution}
                 uid={this.props.uid}
                 db={this.props.db}
                 sessionid={this.props.sessionid}
                 columnType="ask" 
                 players={this.state.asks}
                 solo = {this.props.solo} 
                 creator = {this.props.creator}
                />
              </div>
            </div>
        );
    }
}

export default DealerContainer;



// WEBPACK FOOTER //
// ./src/components/Orderbook/DealerContainer.js